import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import styles from './styles';
import { IconLoading } from 'gatorcomponents';


const Loader = ({
  classes,
  fullscreen,
  positionFixed = false,
  size,
  classesToProps,
  dataId,
  ...res
}) => {
  const getSize = () => {
    if (size >= 33) {
      return 'xl';
    }

    if (size >= 25) {
      return 'lg';
    }

    if (size >= 16) {
      return 'md';
    }

    if (size <= 23) {
      return 'sm';
    }

    return 'lg';
  };


  const getFullScreenClass = () => (positionFixed ? classes.fullscreenPositionFixed : classes.fullscreen);

  return (
    <div {...res} className={classNames(fullscreen ? getFullScreenClass() : classes.loader, classesToProps)}>
      <IconLoading size={getSize()} testId={dataId} />
    </div>
  );
};

Loader.propTypes = {
  classes: PropTypes.object.isRequired,
  classesToProps: PropTypes.string,
  fullscreen: PropTypes.bool,
  positionFixed: PropTypes.bool,

};

export default withStyles(styles)(Loader);
